/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Node.js ES import.
// - Nutná migrace na Node 14+ pro podporu importů
/* eslint-env node */

/**
 * Utility pro operace s Promise.
 */
class PromiseUtil {
  /**
   * Funguje podobně jako standardní `Promise.all`, akorát se jednotlivé Promise
   * volají sériově a nikoliv paralelně.
   *
   * Nedostatky a nepodporované funkcionality:
   * - Vstup by měl být Iterable, ale podporováno je zatím jen Array.
   * - Vyžaduje se, aby funkce vraceli Promise.
   * - Dokumentace by měla používat generics, aby bylo jasné, co se vrací.
   * - Pravděpodobně i další, nebylo implementováno do detailu dle specifikace.
   *
   * Zdroje:
   * - [MDN Promise.all](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/all)
   * @param {Array.<Function>} array
   * @returns {Promise.<Array.<*>>}
   */
  allSerial(array) {
    return new Promise((resolve) =>
      resolve(
        array.reduce(
          (acc, fn) =>
            acc.then((results) =>
              fn().then((result) => {
                results.push(result);
                return results;
              })
            ),
          Promise.resolve([])
        )
      )
    );
  }

  /**
   * Volá opakovaně asynchronní metodu dokud neuspěje.
   * Po každém neúspěšném pokusu se aplikuje zpožení.
   *
   * Zdroje:
   * - [Promise Retry Design Patterns](https://stackoverflow.com/a/44577075)
   * @param {number} delay Čas po který se čeká,
   * po každém neúspěšném pokusu. [ms]
   * @param {number} max Maximání počet neúspěšných pokusů.
   * @param {Function} operation Asynchronní operace, která se opakuje.
   * @returns {Promise.<undefined>}
   */
  retry(delay, max, operation) {
    return new Promise((resolve) =>
      resolve(
        operation().catch((error) => {
          if (!(max > 0)) {
            throw error;
          }
          return resolve(
            this.wait(delay).then(() => this.retry(delay, max - 1, operation))
          );
        })
      )
    );
  }

  /**
   * Počká dokud neuplyne pořadovaný čas.
   * @param {number} delay Čas po který se čeká, než se Promise vyřeší. [ms]
   * @returns {Promise.<undefined>}
   */
  wait(delay) {
    return new Promise((resolve) => setTimeout(resolve, delay));
  }
}

module.exports = PromiseUtil;
